export const BASE_URL = process.env['REACT_APP_BASE_PATH']
export const API_URL = process.env['REACT_APP_OPEN_API_BASE_PATH']
export const TOKEN = process.env['REACT_APP_API_TOKEN']
export const STRIPE_PK = process.env['REACT_APP_STRIPE_PK']
export const ADMIN_USER = process.env['REACT_APP_ADMIN_USERNAME']
export const ADMIN_PW = process.env['REACT_APP_ADMIN_PASSWORD']
export const MAPBOX_KEY = process.env['REACT_APP_MAPBOX_KEY']